const state = {
  listBusinessAccount: [],
  employerDetail: {},
  listConnectionCommentEmployer: [],
  listEducationTrainingEmployer: [],
  listHistoryEmployer: [],
  totalHistoryEmployer: 0,
  listHistoryEmployerAdded: [],
  totalHistoryEmployerAdded: 0,
  listNoticeBoardEmployer: [],
  listProudOfEmployer: [],
  listWorkingPortfolioEmployer: [],
  listEmploymentHistoryEmployer: [],
  talentDetail: {},
  listConnectionComment: [],
  listEducationTraining: [],
  listWorkingHistory: [],
  totalWorkingHistory: 0,
  listNoticeBoard: [],
  listProudOf: [],
  listWorkingPortfolio: [],
  listHistoryTalentAdded: [],
  totalHistoryTalentAdded: 0,
  allowBackPage: [true, true, true, true, true, true, true],
  listJobsToMakeOffer: []
}

export default state
